export default __webpack_public_path__ + "static/media/Overdraft_Declaration.13b9492d.pdf";